import { VerifyCode } from "../../components/verifyCode/VerifyCode"

export const VerificationCode =()=>{
    return(
        <div>
            <VerifyCode />
        </div>
    )
}
